<template>
  <v-dialog v-model="localDialog" width="60%" @update:modelValue="updateDialog" transition=""persistent :open-delay="0" :close-delay="0">
    <v-card>
        <v-card-title class="text-h6">
            <span>{{ isEntryMode ? 'Add Company Module' : 'Update Company Module' }}</span>
        </v-card-title>

        <v-divider></v-divider>

        <v-card-text>
            <v-form @submit.prevent="submit" ref="CompnaySetup">
              <v-row class="ma-0">
                <v-col cols="12" md="6" lg="6" class="pa-2">
                  <v-autocomplete
                    variant="outlined"
                    density="compact"
                    bg-color="grey-lighten-4"
                    v-model="company_id.value.value"
                    :items="getCompanyList.filter(item=> item.status == 1)"
                    :item-title="item => item && item.name && item.code ? `${item.name} - ${item.code}` : ''"                                                  
                    item-value="id"
                    :error-messages="company_id.errorMessage.value"
                    clearable        
                    @update:modelValue="company_id.value.value = $event"             
                  >
                    <template #label>
                      Company <span class="text-red-accent-4">*</span>
                    </template>
                  </v-autocomplete> 
                </v-col>

                <v-col cols="12" class="pa-2 mt-1">
                      <div class="d-flex align-center mb-1">
                        <v-checkbox
                          density="compact"
                          hide-details
                          color="primary"
                          :model-value="isAllModulesSelected"
                          @update:model-value="toggleAllModules"
                          class="mr-2"
                        >
                          <template v-slot:label>
                            <strong>Select All Modules</strong>
                          </template>
                        </v-checkbox>
                      </div>
                      <v-divider class="mb-1"></v-divider>
                      <v-row class="ma-0">
                        <v-col 
                          v-for="(module, index) in getAvailableModules" 
                          :key="module.id" 
                          cols="6"
                          md="4"
                          lg="4"
                          class="pa-0"
                        >
                          <v-checkbox
                            :id="'module_' + module.id"
                            density="compact"
                            hide-details
                            color="primary"
                            :model-value="selectedModules.includes(module.id)"
                            @update:model-value="toggleModule(module.id, $event)"
                            class="ma-0"
                          >
                            <template v-slot:label>
                              <span class="text-caption">{{ module.name }} {{ module.code ? `- ${module.code}` : '' }}</span>
                            </template>
                          </v-checkbox>
                        </v-col>
                      </v-row>
                      <div v-if="module_id.errorMessage.value" class="text-red text-caption mt-1">
                        {{ module_id.errorMessage.value }}
                      </div>
                  </v-col>
                  
                  <v-checkbox                            
                      label="Active"
                      v-model="status.value.value"
                      :error-messages="status.errorMessage.value"
                      density="compact"
                      variant="outlined"
                      hide-details
                      single-line
                      color="primary"
                      value="1"
                  ></v-checkbox>
                  <input v-model="company_module_id.value.value" type="hidden">
              </v-row>

              <v-divider></v-divider>
              <v-card-actions>
                  <v-layout class="justify-end">
                      <v-btn class="bg-red" variant="flat" type="reset"@click="closeDialog">Close</v-btn>
                        <v-btn 
                        class="bg-brand w-15 ms-2"  
                        variant="flat" 
                        type="submit"
                        >
                        {{ isEntryMode ? 'Save' : 'Update' }}
                        </v-btn>
                  </v-layout>
              </v-card-actions>
            </v-form>
        </v-card-text>
      
    </v-card>
  </v-dialog>
</template>

<script>
import { ref, watch } from 'vue'
import { useStore } from 'vuex'
import { useField, useForm } from 'vee-validate'
import * as yup from 'yup'
import { toast } from 'vue3-toastify'

export default {
  name: 'CompanyModuleSetup',
  props: {
    dialog: {
      type: Boolean,
      default: false
    },
    data: {
      type: Object,
      default: () => ({
        company_id: '',
        module_id: '',
        status: '1',
        company_module_id: null,
      })
    }
  },
  data() {
    return {
      localDialog: this.dialog,
      errorMessages: '',
      loading: false,
      isEntryMode: true,
      tempId: '',
      selectedModules: []
    }
  },
  computed: {
    getCompanyList() {
        return this.$store.getters.getCompanyList;
    },
    getModuleList() {
        return this.$store.getters.getModuleList;
    },
    getTempCompanyModuleList() {
        return this.$store.getters.getTempCompanyModuleList;
    },
    getCompanyModuleList() {
        return this.$store.getters.getCompanyModuleList;
    },
    getAvailableModules() {
      if (!this.company_id.value.value) {
        return [];
      }
      // Show all active modules for selection
      return this.getModuleList.filter(module => module.status == 1);
    },
    isAllModulesSelected() {
      if (this.getAvailableModules.length === 0) return false;
      return this.getAvailableModules.every(module => this.selectedModules.includes(module.id));
    }
  },
  watch: {
    dialog(val) {
      this.localDialog = val
    },
    localDialog(val) {
      this.$emit('update:dialog', val)
    },
    data: {
      handler(newData) {
        this.isEntryMode = !newData.id;
        this.resetForm({ errors: {}, touched: {} });
        this.company_id.setValue(newData.company_id || '', false);
        this.status.setValue(String(newData.status) || '1', false);
        this.company_module_id.setValue(newData.id || '', false);
        
        // Set selected modules - for edit mode, show all assigned modules for this company
        if (newData.company_id) {
          // Get all modules already assigned to this company
          const assignedModules = this.getCompanyModuleList
            .filter(item => item.company_id == newData.company_id)
            .map(item => item.module_id);
          
          this.$nextTick(() => {
            this.selectedModules = [...assignedModules];
            this.module_id.setValue([...assignedModules], false);
          });
        } else {
          this.selectedModules = [];
          this.module_id.setValue([], false);
        }
      },
      deep: true,
      immediate: true
    },
    'company_id.value.value'() {
      // When company changes, clear selections
      this.selectedModules = [];
      this.module_id.setValue([], false);
    }
  },
  created() {
        if(this.$store.getters.getCompanyList.length == 0){
            this.loading = true;
                this.$store.dispatch('getCompanyList').then((response) => {
                this.loading = false;
            })
        };

        if(this.$store.getters.getModuleList.length == 0){
            this.loading = true;
                this.$store.dispatch('getModuleList').then((response) => {
                this.loading = false;
            })
        };

        if(this.$store.getters.getCompanyModuleList.length == 0){
                this.loading = true;
                 this.$store.dispatch('getCompanyModuleList').then((response) => {
                    this.loading = false;
                })
        };
    },
  methods: {
    updateDialog(val) {
      this.$emit('update:dialog', val)
    },
    closeDialog() {
        this.selectedModules = [];
        this.module_id.setValue([], false);
        this.$emit('update:dialog', false);
    },
    toggleModule(moduleId, value) {
      if (value) {
        if (!this.selectedModules.includes(moduleId)) {
          this.selectedModules.push(moduleId);
        }
      } else {
        this.selectedModules = this.selectedModules.filter(id => id !== moduleId);
      }
      // Update the form field with the selected modules
      this.$nextTick(() => {
        this.module_id.setValue([...this.selectedModules], true);
      });
    },
    toggleAllModules(value) {
      if (value) {
        this.selectedModules = this.getAvailableModules.map(module => module.id);
      } else {
        this.selectedModules = [];
      }
      // Update the form field with the selected modules
      this.$nextTick(() => {
        this.module_id.setValue([...this.selectedModules], true);
      });
    }
  },
  setup(props, { emit }){
    const { handleSubmit, resetForm} = useForm({
      validationSchema: yup.object({
          company_id: yup.number().positive().integer().required().label('Company'),
          module_id: yup.array().of(yup.number().positive().integer()).min(1, 'Please select at least one module').required().label('Module'),
      }),

    });

    const company_id = useField('company_id');
    const module_id = useField('module_id');
    const status = useField('status');
    const company_module_id = useField('company_module_id');
    const errorMessages  = ref('');
    const loading  = ref('');
    const buttonText  = ref('');
    buttonText.value = 'Save';
    const store = useStore();

    const submit = handleSubmit(async (values) => {
        // Ensure module_id is an array
        const moduleIds = Array.isArray(values.module_id) 
            ? values.module_id 
            : [values.module_id].filter(Boolean);
        
        if (moduleIds.length === 0) {
            toast.error('Please select at least one module');
            return;
        }

        loading.value = true;
        
        try {
            
            await store.dispatch("saveUpdateCompanyModule", {
                company_id: values.company_id,
                module_id: moduleIds,  
                status: values.status || '1',
            });
            
            resetForm();
            emit('update:dialog', false);
            toast.success('Successfully Saved');
            
            // Reload company module list
            await store.dispatch('getCompanyModuleList');
            
        } catch (error) {
            toast.error(error.response?.data?.message || 'Failed to save company modules');
        } finally {
            loading.value = false;
        }
    });
    return {
      submit,
      company_id,
      module_id,
      status,
      errorMessages,
      company_module_id,
      buttonText,
      resetForm,
      loading
    }
  },
  mounted() {
  }
}
</script>

